var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.229,
    height: 19.229,
    viewBox: "0 0 19.229 19.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M3588.685,58.6l-8.208-8.209a.263.263,0,0,1,0-.372l8.209-8.209a.265.265,0,0,0,0-.373l-.77-.769a.263.263,0,0,0-.372,0l-8.209,8.209a.264.264,0,0,1-.373,0l-8.209-8.209a.262.262,0,0,0-.372,0l-.77.769a.264.264,0,0,0,0,.373l8.209,8.209a.263.263,0,0,1,0,.372l-8.209,8.209a.264.264,0,0,0,0,.373l.77.769a.262.262,0,0,0,.372,0l8.209-8.209a.264.264,0,0,1,.373,0l8.208,8.209a.264.264,0,0,0,.373,0l.769-.769A.264.264,0,0,0,3588.685,58.6Z",
    transform: "translate(-3569.534 -40.589)",
    fill: "#5d5f60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.f0ae74ed3aa9e204a71bc30c7a2d59be.svg";
export { ForwardRef as ReactComponent };